/* CAUTION, THIS FILE IS AUTO-GENERATED */
/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import { withIconFlavour } from '../withIconFlavour';

const IconMiscButterflyHex = ({ size = 16, className = '', ...props }) => (
  <svg
    {...props}
    className={className}
    width={size}
    height={size}
    viewBox="0 0 13.986 15.984"
  >
    <path
      fill="currentColor"
      d="M13.054 12.689l-5.128 3.039a1.823 1.823 0 0 1-1.865 0L.933 12.689A1.923 1.923 0 0 1 0 11.031V4.953c0-.684.355-1.316.932-1.658L6.06.256a1.823 1.823 0 0 1 1.865 0l5.128 3.039c.577.342.932.974.932 1.658v6.078a1.92 1.92 0 0 1-.931 1.658zM9.236 3.487c-.198 0-.284.128-.356.259L5.924 9.111l1.888 3.545c.065.121.167.259.37.259H9.51c.08 0 .142-.031.177-.087.035-.058.034-.135-.003-.21L7.81 9.116a.014.014 0 0 1 0-.009l2.941-5.323c.037-.075.038-.152.003-.21-.034-.056-.097-.087-.177-.087H9.236zm-5.582 1.86c-.08 0-.143.031-.176.087-.036.058-.034.135.002.21l.903 1.587a.014.014 0 0 1 0 .009L2.968 9.792c-.037.075-.038.152-.002.21.033.056.097.087.176.087h1.332c.199 0 .288-.134.356-.259l1.439-2.593-.917-1.63c-.066-.121-.167-.26-.371-.26H3.654z"
    />
  </svg>
);

IconMiscButterflyHex.displayName = 'IconMiscButterflyHex';

IconMiscButterflyHex.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
};

export default withIconFlavour(IconMiscButterflyHex);
IconMiscButterflyHex.displayName = 'IconMiscButterflyHex';
